import { memo, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { mainRouters } from "./registryRoutes";
import slugs from "./slugs";
import { useAuth } from "contexts/authContext";
import { MainLayoutPublib } from "components/layouts/MainLayoutPublib";
import { ReactComponent as Icon } from "assets/images/icon.svg";
import { usePrivy } from "@privy-io/react-auth";
import { isMobile } from "react-device-detect";

const AppRouter = memo(() => {
  const { token, referrerId, isVerifyTiktok, isDepositEth, isBuyFirstShares } =
    useAuth();

  const navigate = useNavigate();
  const isInAuth = !token;
  const isInInvitePage = !isInAuth && (!referrerId || referrerId === "null");
  const isInTiktokPage = !isInInvitePage && !isVerifyTiktok;
  const isInDepositEth = !isInTiktokPage && !isDepositEth;
  const isInBuyFirstShares = !isInDepositEth && !isBuyFirstShares;
  const { pathname } = useLocation();

  const isInStandaloneMode = window.matchMedia(
    "(display-mode: standalone)"
  ).matches;

  console.log("path&mode", pathname, isInStandaloneMode);

  useEffect(() => {
    if (!isInStandaloneMode) return;

    switch (true) {
      case isInAuth:
        navigate(slugs.login, { replace: true });
        break;

      case isInInvitePage:
        navigate(slugs.inviteCode, { replace: true });
        break;

      case isInTiktokPage:
        navigate(slugs.accountVerify, { replace: true });
        break;

      case isInDepositEth:
        navigate(slugs.depositEth, { replace: true });
        break;

      case isInBuyFirstShares:
        navigate(slugs.buyFirstShare, { replace: true });
        break;
    }
  }, [
    isInAuth,
    isInBuyFirstShares,
    isInDepositEth,
    isInInvitePage,
    isInStandaloneMode,
    isInTiktokPage,
    isVerifyTiktok,
    navigate,
    referrerId,
  ]);

  return (
    <Routes>
      {mainRouters.map((router) => {
        const {
          component: Component,
          container: Container,
          path,
          isAuthNeeded,
        } = router;

        return (
          <Route
            key={path}
            path={path}
            element={
              isAuthNeeded && isInAuth ? (
                <Navigate to={slugs.login} />
              ) : (
                <Container>
                  <Component />
                </Container>
              )
            }
          />
        );
      })}
    </Routes>
  );
});

const Navigator = () => {
  const { authenticated, ready } = usePrivy();

  return !authenticated && !ready ? (
    <MainLayoutPublib>
      <div className="flex flex-col h-full w-full justify-center items-center z-50">
        <Icon className="w-16 mb-4" />
      </div>
    </MainLayoutPublib>
  ) : (
    <AppRouter />
  );
};

export default Navigator;
